import Auth from '@aws-amplify/auth';

export const getToken = async () => (await Auth.currentSession()).getIdToken().getJwtToken();